
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import {
  authSlice,
  trainingProgrammeSlice,
  userSlice,
  companySlice,
  sdfSlice,
  employeeSlice,
  setaTemplateSlice,
  commonSlice,
  configSlice,
  trainingFormSlice,
  commentSlice,
  trainingCatalogueSlice,
  organogramSlice,
  trainingFormReviewSlice,
  trainingStrategyInputSlice,
  yearSlice,
  dashboardSlice,
  promptMasterSlice,
  raceGroupSlice,
  bBbeeConfigurationSlice,
  trainingCategoryBudgetSlice,
  totalBudgetSlice,
  bulkTrainingAllocationSlice,
  planOptimizerSlice,
  trainingCategoryConfigSlice,
} from "./slices";

// Combine all reducers
const appReducer = combineReducers({
  common: commonSlice,
  auth: authSlice,
  user: userSlice,
  company: companySlice,
  sdf: sdfSlice,
  setaTemplate: setaTemplateSlice,
  employee: employeeSlice,
  trainingProgramme: trainingProgrammeSlice,
  config: configSlice,
  trainingForm: trainingFormSlice,
  comment: commentSlice,
  trainingCatalogue: trainingCatalogueSlice,
  organogram: organogramSlice,
  trainingFormReview: trainingFormReviewSlice,
  trainingStrategyInput: trainingStrategyInputSlice,
  year: yearSlice,
  dashboard: dashboardSlice,
  promptMaster: promptMasterSlice,
  raceGroup: raceGroupSlice,
  bBbeeConfiguration: bBbeeConfigurationSlice,
  trainingCategoryBudget: trainingCategoryBudgetSlice,
  totalBudget: totalBudgetSlice,
  bulkTrainingAllocation: bulkTrainingAllocationSlice,
  planOptimizer: planOptimizerSlice,
  trainingCategoryConfig: trainingCategoryConfigSlice,
});

// Reset all state on logout (fulfilled or rejected) so dashboard cache and other user data never persist after logout
const rootReducer = (state, action) => {
  if (action.type === "auth/logoutUser/fulfilled" || action.type === "auth/logoutUser/rejected") {
    state = undefined;
  }
  return appReducer(state, action);
};

// Persist only the auth slice
const persistConfig = {
  key: "root",
  storage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types from Redux Persist
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/REGISTER",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/FLUSH",
        ],
      },
    }),
});

export const persistor = persistStore(store);
